export default __webpack_public_path__ + "static/PES-mobile-3-7188f6a30880f81707ea1355dcd586da.jpg";